import api from './api'
import bff from './bff'
import apiCallHandler from './apiCallHandler'

export const postCreateCompany = (payload) => {
  return apiCallHandler(() => bff.post(`/register/company`, payload))
}

export const putUpdateCompany = (payload) => {
  return apiCallHandler(() => api.put(`/companies-service/${payload.id}`, payload))
}

export const getCompanyInfo = (site, cnpj) => {
  return apiCallHandler(() => bff.get(`/Register/verifyIfResaleCompanyExist?site=${site}&cnpj=${cnpj}`))
}

export const getActivityBranches = () => {
  return apiCallHandler(() => bff.get(`/Register/Branches`))
}

export const getAddressesTypesForCompanyRegister = () => {
  return apiCallHandler(() => bff.get('/address/address-types'))
}

export const getLaneTypesForCompanyRegister = () => {
  return apiCallHandler(() => bff.get('/address/lane-types'))
}

export const getSession = (site) => {
  return apiCallHandler(() => bff.get(`/session?resale=${site}`))
}

export const getCityCode = (ibge, local) => {
  return apiCallHandler(() => bff.get(`/address/cities?ibge=${ibge}&name=${local}`))
}
